<div class="flex flex-col items-center justify-between md:px-10 xl:w-[1300px]">
  <div
    class="flex w-full max-w-4xl flex-1 flex-col justify-start text-center md:gap-10"
  >
    <div class="flex flex-col gap-4">
      <h2 class="text-primary-900">
        {{ "calculator.createTrip" | transloco }}
      </h2>

      <p class="text-paragraph-s-reg">
        {{ "calculator.createTripModalText" | transloco }}
      </p>
    </div>
    <div
      class="grid w-full grid-cols-1 gap-6 px-4 md:auto-rows-fr md:grid-cols-2 xl:grid-cols-4"
    >
      <button
        class="flex flex-col items-center justify-center gap-3 rounded-lg p-6 text-center shadow-lg transition-shadow"
        [ngClass]="
          packLimitationService.canCreateTrip()
            ? 'hover:shadow-xl'
            : 'cursor-default bg-greyscale-50 opacity-70'
        "
        (click)="
          packLimitationService.canCreateTrip() &&
            tripCreationModalService.createTripWithoutIA()
        "
      >
        <div>
          <i
            class="pi rounded-full bg-primary-50 p-4"
            [ngClass]="
              packLimitationService.canCreateTrip()
                ? 'pi-plus-circle'
                : 'pi-lock'
            "
            style="font-size: 2rem; color: var(--color-primary-500)"
          ></i>
        </div>
        <h4>{{ "calculator.createTripWithoutImport" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.enterInfo" | transloco }}
        </p>
      </button>
      <button
        class="flex flex-col items-center justify-center gap-3 rounded-lg p-6 text-center shadow-lg transition-shadow"
        [ngClass]="
          packLimitationService.canCreateTrip()
            ? 'hover:shadow-xl'
            : 'cursor-default bg-greyscale-50 opacity-70'
        "
        (click)="packLimitationService.canCreateTrip() && createTripWithIA()"
      >
        <div>
          <i
            class="pi rounded-full bg-primary-50 p-4"
            [ngClass]="
              packLimitationService.canCreateTrip()
                ? 'pi-file-import'
                : 'pi-lock'
            "
            style="font-size: 2rem; color: var(--color-primary-500)"
          ></i>
        </div>
        <h4>{{ "calculator.createTripWithImport" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{ "calculator.useIaDescription" | transloco }}
        </p>
      </button>
      <button
        class="flex flex-col items-center justify-center gap-3 rounded-lg p-6 text-center shadow-lg transition-shadow"
        [ngClass]="{
          'hover:shadow-xl':
            packLimitationService.canCreateTrip() &&
            packLimitationService.canUseBulkUpload(),

          'cursor-default': !packLimitationService.canCreateTrip(),
          'bg-greyscale-50 opacity-70':
            !packLimitationService.canCreateTrip() ||
            !packLimitationService.canUseBulkUpload(),
        }"
        (click)="handleBulkIAClick()"
        [pTooltip]="
          !packLimitationService.canUseBulkUpload() &&
          packLimitationService.canCreateTrip()
            ? ('lockedButton.tooltip' | transloco)
            : ''
        "
      >
        <div>
          <i
            class="pi rounded-full bg-primary-50 p-4"
            [ngClass]="
              packLimitationService.canCreateTrip() &&
              packLimitationService.canUseBulkUpload()
                ? 'pi-cloud-upload'
                : 'pi-lock'
            "
            style="font-size: 2rem; color: var(--color-primary-500)"
          ></i>
        </div>
        <h4>{{ "calculator.createTripBulkImport" | transloco }}</h4>
        <p class="text-paragraph-s-reg text-greyscale-700">
          {{
            "calculator.bulkUploadDescription"
              | transloco
                : { maxFiles: packLimitationService.bulkUploadFileLimit() }
          }}
        </p>
      </button>

      @if (features.excelImport) {
        <!-- POC: Excel mass import. No pack/quota check for now. -->
        <button
          class="flex flex-col items-center justify-center gap-3 rounded-lg p-6 text-center shadow-lg transition-shadow hover:shadow-xl"
          (click)="tripCreationModalService.goToExcelImport()"
        >
          <div>
            <i
              class="pi pi-table rounded-full bg-primary-50 p-4"
              style="font-size: 2rem; color: var(--color-primary-500)"
            ></i>
          </div>
          <h4>{{ "calculator.excelImportCardTitle" | transloco }}</h4>
          <p class="text-paragraph-s-reg text-greyscale-700">
            {{ "calculator.excelImportCardDescription" | transloco }}
          </p>
        </button>
      }

      <input
        #fileInput
        type="file"
        [accept]="uploadConfigService.AI_DOCUMENT.accept"
        (change)="onFileSelected($event)"
        [hidden]="true"
      />
    </div>
    <div class="px-4"><app-trip-limit-indicator /></div>
  </div>

  <div class="flex w-full items-end justify-end">
    <p-button
      [label]="'close' | transloco"
      (click)="tripCreationModalService.close()"
      severity="secondary"
      [text]="true"
    />
  </div>
</div>
